import { render, staticRenderFns } from "./addSystem.vue?vue&type=template&id=c842a650&scoped=true&"
import script from "./addSystem.vue?vue&type=script&lang=js&"
export * from "./addSystem.vue?vue&type=script&lang=js&"
import style0 from "./addSystem.vue?vue&type=style&index=0&id=c842a650&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c842a650",
  null
  
)

export default component.exports